import React from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';

export class FooterImage extends React.PureComponent {
    static propTypes = {
        footerImage: PropTypes.string,
        footerSmallImage: PropTypes.string,
    };

    state = {
        visible: false,
    };

    _handleWaypointEnter = () => {
        this.setState({ visible: true });
    };

    render() {
        const { footerImage, footerSmallImage } = this.props;

        let component = null;

        if (footerImage && footerSmallImage) {
            if (this.state.visible) {
                component = (
                    <div className="branding-image-container eds-align--center-horizontal eds-l-mar-top-20">
                        <img
                            srcSet={`
                                ${footerSmallImage} 512w,
                                ${footerImage} 1272w
                            `}
                            sizes="
                                (max-width: 512px) 200vw,
                                1272px
                            "
                            src={footerImage}
                            alt=""
                            className="branding-image-container__footer-image"
                        />
                    </div>
                );
            }
        }

        return (
            <Waypoint onEnter={this._handleWaypointEnter}>{component}</Waypoint>
        );
    }
}
